import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, renderSlot as _renderSlot, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["data-layout"]

import type { CheckboxFormOption } from '@src/components/shared/form_fields/FormOptions';
import RadioFormInput from '@src/components/shared/form_elements/RadioFormInput.vue';
import { useFieldModel } from '@src/components/shared/form_fields/useFieldModel';
import { computed } from 'vue';
import { useAriaDescribedby } from '@src/components/shared/composables/useAriaDescribedby';
import FieldContainer from '@src/components/patterns/FieldContainer.vue';

interface Props {
	label?: String;
	name: string;
	modelValue: string | number | boolean | null;
	options: CheckboxFormOption[];
	disabled?: Array<string | number | boolean>;
	showError?: boolean;
	errorMessage?: String;
	layoutType?: 'cluster' | 'grid';
	gridLayout?: 'full' | '50-50' | 'halves' | 'thirds' | 'quarters';
	autofocus?: boolean;
	ariaDescribedby?: string | undefined;
	isMaxWidthField?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RadioField',
  props: {
    label: {},
    name: {},
    modelValue: { type: [String, Number, Boolean, null] },
    options: {},
    disabled: { default: () => [] },
    showError: { type: Boolean, default: false },
    errorMessage: {},
    layoutType: { default: 'grid' },
    gridLayout: { default: 'full' },
    autofocus: { type: Boolean },
    ariaDescribedby: {},
    isMaxWidthField: { type: Boolean }
  },
  emits: [ 'update:modelValue', 'field-changed' ],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const ariaDescribedby = useAriaDescribedby(
	props.name,
	computed<boolean>( () => false ),
	computed<boolean>( () => props.showError ),
	computed<boolean>( () => false ),
	computed<string | undefined>( () => props.ariaDescribedby )
);

const fieldModel = useFieldModel<string | number | boolean | null>( () => props.modelValue, props.modelValue );

const onFieldChange = ( newValue: string | number | boolean | null ): void => {
	emit( 'update:modelValue', newValue );
	emit( 'field-changed', props.name );
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FieldContainer, {
    "input-id": __props.name,
    "show-error": __props.showError,
    type: "fieldset",
    "is-max-width-field": __props.isMaxWidthField
  }, {
    label: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.label), 1)
    ]),
    field: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(__props.layoutType),
        "data-layout": __props.gridLayout
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
          return (_openBlock(), _createBlock(RadioFormInput, {
            key: index,
            id: option.id,
            name: __props.name,
            disabled: __props.disabled.includes( option.value ),
            "native-value": option.value,
            "aria-describedby": _unref(ariaDescribedby),
            "aria-invalid": __props.showError,
            modelValue: _unref(fieldModel),
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (_isRef(fieldModel) ? (fieldModel).value = $event : null)),
              onFieldChange
            ],
            autofocus: __props.autofocus
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(option.label), 1)
            ]),
            "help-text": _withCtx(() => [
              _renderSlot(_ctx.$slots, `message-${option.value}`)
            ]),
            tooltip: _withCtx(() => [
              _renderSlot(_ctx.$slots, `tooltip-${option.value}`)
            ]),
            _: 2
          }, 1032, ["id", "name", "disabled", "native-value", "aria-describedby", "aria-invalid", "modelValue", "autofocus"]))
        }), 128))
      ], 10, _hoisted_1)
    ]),
    error: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.errorMessage), 1)
    ]),
    _: 3
  }, 8, ["input-id", "show-error", "is-max-width-field"]))
}
}

})